<script setup lang="ts">

import BaseButton from '@/components/base/BaseButton.vue'
import { T } from '@tolgee/vue'
import { useTonConnectModal } from '@townsquarelabs/ui-vue'
import { useWalletConnect } from '@/composables/game/wallet-connect'
import ConnectedWallet from '@/components/ConnectedWallet.vue'

const props = withDefaults(defineProps<{
  buttonHasIcon?: boolean,
  disableDisconnect?: boolean
}>(), {
  buttonHasIcon: false,
  disableDisconnect: false,
})

const { open } = useTonConnectModal()
const { rawAddress } = useWalletConnect()

function tonConnectClick() {
  open()
}

</script>

<template>
  <div
    class="w-full relative"
    v-if="!rawAddress"
  >
    <BaseButton
      class="w-full"
      @click="tonConnectClick"
    >
      <template
        v-if="buttonHasIcon"
        #leftIcon
      >
        <img
          src="@/assets/images/gifs/money.gif"
          class="h-full w-auto max-w-[24px]"
        >
      </template>
      <T
        key-name="wallet.connect_wallet"
        default-value="Connect wallet"
      />
    </BaseButton>
  </div>
  <ConnectedWallet
    v-else
    :disable-disconnect="disableDisconnect"
  />
</template>

<style scoped>

</style>